"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseViewModel_1 = require("../../viewModels/base/baseViewModel");
var ko = require("knockout");
var BaseComponent = (function (_super) {
    __extends(BaseComponent, _super);
    function BaseComponent(params, element, templateNodes) {
        _super.call(this);
        this.processing = ko.observable(false);
        this.params = params;
        this.element = element;
        this.templateNodes = templateNodes;
    }
    BaseComponent.prototype.reloadPage = function () {
        window.location.reload(true);
    };
    BaseComponent.prototype.handleRefreshWorkMetaInfo = function (app, workId) {
        try {
            if (app.canBeHandledByApp()) {
                app.getAppMobileHandler().handleRefreshWorkMetaInfo(workId);
                return;
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    return BaseComponent;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BaseComponent;
//# sourceMappingURL=BaseComponent.js.map